<template>
  <v-icon
    :class="computedClasses"
    :color="tile ? 'white' : color"
    :x-small="extraSmall"
    :small="small"
    :medium="medium"
    :large="large"
    :x-large="extraLarge"
  >
    {{ icon }}
  </v-icon>
</template>

<script>
export default {
  name: "Icon",
  props: {
    icon: {
      type: String,
      required: true,
      validator: (value) => value.includes("mdi-"),
    },
    color: {
      type: String,
      default: "systemPrimary",
    },
    tile: {
      type: Boolean,
      default: false,
    },
    extraSmall: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    medium: {
      type: Boolean,
      default: true,
    },
    large: {
      type: Boolean,
      default: false,
    },
    extraLarge: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedClasses() {
      let classes = [];
      if (this.tile) {
        classes.push(...["rounded", "icon-tile"]);

        // TO DO: Change with Vuetify 3
        // Vuetify 2 background color classes are just sent as the color name
        classes.push(this.color);
        // Vuetify 3 background color classes are sent as bg-<color>
        classes.push(`bg-${this.color}`);
      }
      return classes;
    },
  },
};
</script>

<style scoped>
.icon-tile {
  padding: 6px;
}
</style>
